<template>
  <div class="main-content">
    <div class="logoAndSearchbox">
      <div class="logo-container">
        <img src="@/assets/img/CA_Logo_black.png" alt="Logo Icon" class="logo-icon">
        
        <div class="text-container">
          <div class="chess-line">
            <span class="metallic-text">CH</span>
            <img src="@/assets/img/E_Black_transparent.png" alt="E" class="letter-e">
            <span class="metallic-text">SS</span>
          </div>
          <div class="administrator-line metallic-text">ADMINISTRATOR</div>
          <div class="metallic-line"></div>
          <h2 class="sub-line">Tournament Results Management</h2>
        </div>
      </div>
    
      <div class="searchArea" :class="{ 'searchAreaUp': resultsShown }">
        <div style="flex: 1;">
          <input id="nameField" type="text" class="search-box" v-model.lazy="searchString" v-debounce="1000" :placeholder="$t('dashboard.search')" autofocus>
        </div>
        <div><font-awesome-icon icon="search" class="inputImage"/></div>
        <div v-if="isLoading" class="spincontainer">
          <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
        </div>
      </div>
    </div>

    <!-- temporary test for swag 
     <br/><br/>
      <div class="logo-container2">
        <img src="@/assets/img/CA_Logo_black.png" alt="Logo Icon" class="logo-icon2">
        
        <div class="text-container2">
          <div class="chess-line2">
            <span class="metallic-text2">CH</span>
            <img src="@/assets/img/E_Black_transparent.png" alt="E" class="letter-e2">
            <span class="metallic-text2">SS</span>
          </div>
          <div class="administrator-line2 metallic-text2">ADMINISTRATOR</div>
          <div class="metallic-line2"></div>
          <h2 class="sub-line2">Make a good move, buy our merch!</h2>
        </div>
      </div>
    end test -->

    <div class="results-area">
      <tournaments-list v-if="tournaments.length != 0" 
        :tournaments="tournaments" 
        :listType="'Table'"
        :topX="4"></tournaments-list>

      <clubs-list v-if="clubs.length != 0" 
        :clubs="clubs" 
        :listType="'Table'"
        :topX="4"></clubs-list>

      <persons-list v-if="persons.length != 0" 
        :persons="persons" 
        :listType="'Table'"
        :optionSelectAll="false"
        :topX="4"></persons-list>

      <h5></h5>
      <involvements v-if="showInvolvements"></involvements>
    </div>


    <!-- h5 v-if="showInvolvements"> {{$t('dashboard.involvement')}} </h5 -->
    <!--
    <h5 v-if="visitsAvailable"> {{$t('dashboard.recentlyVisited')}} </h5>
    <recently-visited v-if="visitsAvailable"></recently-visited>
    -->
  </div>
</template>

<script>

import v4 from 'uuid'
import PersonsList from "@/components/players/PersonsList";
import {RestAPI} from "@aws-amplify/api-rest";
import TournamentsList from "@/components/tournaments/TournamentsList";
import ClubsList from "@/components/clubs/ClubsList";
import RecentlyVisited from './RecentlyVisited.vue';
import Involvements from './Involvements.vue';

const apiName = 'api';
const myInit = { 
  response: false, 
};

export default {
  name: 'Dashboard',
  components: {ClubsList, PersonsList, RecentlyVisited, TournamentsList, Involvements},
  data: function () {
    return {
      searchString: "",
      clubs: [],
      persons: [],
      tournaments: [],
      loading: 0
    }
  },
  beforeMount() {
    console.log("hideChessSplash waarde: " + localStorage.getItem('hideChessSplash'));
    var goToSplash = (localStorage.getItem('hideChessSplash') == null);
    if (!goToSplash)
      goToSplash = !localStorage.getItem('hideChessSplash');
    if (goToSplash)
      this.$router.push("info/about");
  },
  computed: {
    isLoading() {
      return this.loading != 0;
    },
    loggedIn: function () {
      return this.$CAUser.loggedIn();
    },
    resultsShown: function() {
      return (this.clubs.length + this.persons.length + this.tournaments.length) > 0;
    },
    visitsAvailable: function() {
      var visits = this.$CA_Storage.getVisits();
      return visits.length > 0;
    },
    showInvolvements: function() {
      return this.$CAUser.loggedIn();
    }
  },
  watch: {
    searchString: function () {
      if (this.searchString != "") {
        this.loading = 3;
        this.loadPersons(this.searchString);
        this.loadTournaments(this.searchString);
        this.loadClubs(this.searchString);
      } else {
        this.clubs = [];
        this.persons = [];
        this.tournaments = [];
        this.loading = 0;
      }
    }
  },
  methods: {

    click() {
      this.$router.push({name: 'EditTournamentDetails', params: {tournamentId: v4()}, query: {mode: 'create'}})
    },

    loadClubs: function(name) {
      let that = this;
      const listPath = '/club';
      let fullPath = listPath + "?name=" + encodeURIComponent(name);
      console.log("loading clubs from: " + fullPath);
      RestAPI
        .get(apiName, fullPath, myInit)
        .then(response => {
          that.clubs = response
          console.log("clubs loaded: " + that.clubs.length);
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally( () => {
          that.loading = that.loading - 1;
        });
    },

    loadTournaments: function(name) {
      let that = this;
      const listPath = '/tournament';
      let fullPath = listPath + "?name=" + encodeURIComponent(name);
      console.log("loading tournaments from: " + fullPath);
      RestAPI
        .get(apiName, fullPath, myInit)
        .then(response => {
          that.tournaments = response
          console.log("tournaments loaded: " + that.tournaments.length);
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally( () => {
          that.loading = that.loading - 1;
        });
    },

    loadPersons: function(name) {
      let that = this;
      const listPath = '/person';
      let fullPath = listPath + "?name=" + encodeURIComponent(name);
      console.log("loading persons from: " + fullPath);
      RestAPI
        .get(apiName, fullPath, myInit)
        .then(response => {
          that.persons = response
          console.log("persons loaded: " + that.persons.length);
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally( () => {
          that.loading = that.loading - 1;
        });
    }

 },
}
</script>

<style scoped>

.logoAndSearchbox {
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 1; 
  flex-grow: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.logo-display {
  width: 100%;
  max-width: 300px;
  height: auto;
  margin-bottom: 30px; 
}

.main-content {
  display: flex;
  flex-direction: column; 
  margin-left: auto;
  margin-right: auto;
  min-height: calc(100vh - 97px); /*complete view, minus menu and footer*/
  width: 100%;
  max-width: 1200px;
  padding: 0 1vw;
  box-sizing: border-box;
}

.infoLink {
  position: relative;
  right: -14px;
  top: -30px;
}

.results-area {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 800px;
  min-height: 0;
  overflow-x: auto;
}

.top {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.searchArea {
  margin-bottom: 10px;
  display: flex; 
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 0 auto; /* Centreer de container */ 
  transition: margin 1.7s ease-in-out;
  box-sizing: border-box;
}

/* LOGO CSS */
/* Main Container */
  .logo-container {
    display: flex;
    align-items: center;
    font-family: 'Montserrat', sans-serif; /* Use a bold, clean font */
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 8px;
  }

  /* Left Logo Icon */
  .logo-icon {
    /* Adjust height to match the original */
    height: 90px;
    margin-right: 20px;
  }

  /* Right Text Container */
  .text-container {
    display: flex;
    flex-direction: column;
  }

  /* "CHESS" Line */
  .chess-line {
    display: flex;
    align-items: flex-end; /* Align letters at the bottom */
    font-size: 28px;
    line-height: 0.8;
    margin-bottom: -5px; /* Adjust spacing between lines */
  }

  /* The image of the letter 'E' */
  .letter-e {
    height: 21px; /* Match the font size */
    margin: 0px; /* Adjust spacing around the E */
    margin-bottom: 1px;
  }

  /* "ADMINISTRATOR" Line */
  .administrator-line {
    font-size: 28px;
    line-height: 0.8;
    margin-bottom: 10px;
    margin-top: 8px;
  }

  /* Horizontal Metallic Line */
  .metallic-line {
    height: 5px; /* Thickness of the line */
    width: 100%;
    /* Linear gradient to create a metallic cylinder look */
    background: linear-gradient(to bottom, #d0d0d0 0%, #f0f0f0 40%, #c0c0c0 60%, #a0a0a0 100%);
    border-radius: 2px;
    margin-bottom: -8px;
  }

  /* "Tournament Results Management" Line */
  .sub-line {
    font-size: 14px;
    font-weight: 700;
    color: #555; /* A solid dark gray for the subtitle */
    letter-spacing: 0.5px;
  }

  /* --- CSS for Metallic Text Effect --- */
  .metallic-text {
    font-weight: 600; 
    color: #c0c0c0; /* Fallback color */
    
    /* Gradient background clipped to the text */
    background: linear-gradient(to bottom, 
      #ffffff 0%, 
      #e0e0e0 30%, 
      #c0c0c0 50%, 
      #e0e0e0 70%, 
      #b0b0b0 100%
    );

    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    
    /* Text shadow for a subtle 3D bevel effect */
    text-shadow: 
      1px 1px 1px rgba(0, 0, 0, 0.3),
      -0.5px -0.5px 1px rgba(255, 255, 255, 0.8);
    
    /* Optional drop shadow for depth */
    filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.2));
  }

/* LOGO CSS */
/* Main Container */
  .logo-container2 {
    display: flex;
    align-items: center;
    font-family: 'Montserrat', sans-serif; /* Use a bold, clean font */
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 8px;
  }

  /* Left Logo Icon */
  .logo-icon2 {
    /* Adjust height to match the original */
    height: 200px;
    margin-right: 20px;
  }

  /* Right Text Container */
  .text-container2 {
    display: flex;
    flex-direction: column;
  }

  /* "CHESS" Line */
  .chess-line2 {
    display: flex;
    align-items: flex-end; /* Align letters at the bottom */
    font-size: 60px;
    line-height: 1;
    margin-bottom: -5px; /* Adjust spacing between lines */
  }

  /* The image of the letter 'E' */
  .letter-e2 {
    height: 43px; /* Match the font size */
    margin: 0px; /* Adjust spacing around the E */
    margin-bottom: 9px;
  }

  /* "ADMINISTRATOR" Line */
  .administrator-line2 {
    font-size: 60px;
    line-height: 0.8;
    margin-bottom: 10px;
    margin-top: 8px;
  }

  /* Horizontal Metallic Line */
  .metallic-line2 {
    height: 5px; /* Thickness of the line */
    width: 100%;
    /* Linear gradient to create a metallic cylinder look */
    background: linear-gradient(to bottom, #d0d0d0 0%, #f0f0f0 40%, #c0c0c0 60%, #a0a0a0 100%);
    border-radius: 2px;
    margin-bottom: -8px;
  }

  /* "Tournament Results Management" Line */
  .sub-line2 {
    font-size: 32px;
    font-weight: 700;
    color: #555; /* A solid dark gray for the subtitle */
    letter-spacing: 2px;
  }

  /* --- CSS for Metallic Text Effect --- */
  .metallic-text2 {
    font-weight: 600; 
    color: #c0c0c0; /* Fallback color */
    
    /* Gradient background clipped to the text */
    background: linear-gradient(to bottom, 
      #ffffff 0%, 
      #e0e0e0 30%, 
      #c0c0c0 50%, 
      #e0e0e0 70%, 
      #b0b0b0 100%
    );

    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    
    /* Text shadow for a subtle 3D bevel effect */
    text-shadow: 
      1px 1px 1px rgba(0, 0, 0, 0.3),
      -0.5px -0.5px 1px rgba(255, 255, 255, 0.8);
    
    /* Optional drop shadow for depth */
    filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.2));
  }

/* mobile */
@media screen and (max-width: 600px) {
  .logoAndSearchbox {
    width: 95vw;
    max-width: 95vw;
    padding-top: 10px;
  }

  .logo-icon {
    height: 60px;
    margin-right: 10px;
  }

  .chess-line {
    font-size: 18px;
  }

  .letter-e {
    height: 14px;
  }

  .administrator-line {
    font-size: 18px;
  }

  .searchArea {
    width: calc(100% - 16px);  
    box-sizing: border-box;
  }

.sub-line {
    font-size: 10px;
  }

  .main-content {
    width: 100%;
    padding: 0 2vw;
  }

  .results-area {
    width: 100%;
    max-width: 100%;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .logoAndSearchbox {
    width: 80vw;
    max-width: 500px;
  }

  .logo-icon {
    height: 75px;
    margin-right: 15px;
  }

  .chess-line {
    font-size: 22px;
  }

  .letter-e {
    height: 17px;
  }

  .administrator-line {
    font-size: 22px;
  }

  .sub-line {
    font-size: 12px;
  }

  .main-content {
    width: 90vw;
    max-width: 1000px;
  }

  .results-area {
    width: 100%;
    max-width: 100%;
  }

  .searchArea {
    width: 100%;
    max-width: 400px;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .main-content {
    width: 50vw;
    max-width: 1200px;
  }

  .results-area {
    width: 50vw;
    max-width: 800px;
  }
}

</style>

